import { useState, useEffect, useCallback } from 'react'
import { ResultReviewData, getResultReview } from '../apis/prescription'

export const useResultReview = (ocrRequestEventId?: string) => {
  const [data, setData] = useState<ResultReviewData | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const fetchReview = useCallback(async () => {
    if (!ocrRequestEventId) return
    setIsLoading(true)
    setError('')
    try {
      const response = await getResultReview(ocrRequestEventId)
      setData(response.data)
    } catch {
      setError('結果データの取得に失敗しました')
    } finally {
      setIsLoading(false)
    }
  }, [ocrRequestEventId])

  useEffect(() => {
    fetchReview()
  }, [fetchReview])

  return { data, isLoading, error, refetch: fetchReview }
}
